/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 * - joinWaitList
 */

/* B6R-m10: a variant title for people to read, the way snippets/umbra-option-label.liquid prints one value. In a Color,
   Colour or Finish option a hyphen between two letters becomes a space ("Aged-Walnut" reads "Aged Walnut"); every other
   option, every other hyphen and the values of umbra_sweep_hyphen_keep stay as they are. Callers use it only while the
   picker carries data-umbra-hy (snippets/variant-picker.liquid, umbra_sys_sweep on), so the default page is unchanged.
   title: "Aged-Walnut / 4x6"; names: the product's option names in order; keep: the setting's comma-separated list. */
window.umbraOptionLabel = window.umbraOptionLabel || function (title, names, keep) {
  if (typeof title !== 'string' || title.indexOf('-') === -1) return title;
  const list = String(keep || '').split(',').map((k) => k.trim()).filter(Boolean);
  return title.split(' / ').map((value, i) => {
    const n = names && names[i];
    const name = String((n && n.name) || n || '').trim().toLowerCase();
    if ((name !== 'color' && name !== 'colour' && name !== 'finish') || value.indexOf('-') === -1) return value;
    const low = value.toLowerCase();
    if (list.some((k) => k.toLowerCase() === low)) return value;
    let out = value;
    list.forEach((k) => { out = out.split(k).join(k.replace(/-/g, '\u0000')); });
    out = out.replace(/(\p{L})-(?=\p{L})/gu, '$1 ');
    return out.replace(/\u0000/g, '-');
  }).join(' / ');
};

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productInfo = document.querySelector('.product-details');
      this.productForm = this.section.querySelector('.js-product-form-main');
      this.backInStock = this.section.querySelector('back-in-stock');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      if(this.productInfo){
        this.dimsContainer = this.productInfo.querySelector('#variant-dim');
        this.materialContainer = this.productInfo.querySelector('#variant-material');
      }
      this.oversizeContainer = this.section.querySelector("#oversize-callout");
      this.oversizeCharge = this.section.querySelector('#oversize-charge');
      this.tariffContainer = this.section.querySelector("#tariff-callout");
      this.tariffCharge = this.section.querySelector('#tariff-charge');
      this.data = this.getProductData();
      this.hiddenIds = this.getHiddenIds();
      this.visibleVariants = this.data.product.variants.filter(
        (v) => !this.hiddenIds.includes(v.id)
      );
      this.variant = this.getSelectedVariant();
      this.selectedOptions = this.getSelectedOptions();
      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;
      this.tariffData = this.getTariffData();

      this.addEventListener('change', this.handleVariantChange.bind(this));

      // Defer these to allow for quick-add modal to full initialize
      setTimeout(() => {
        this.redirectIfHidden();
        this.updateVisibleOptions();
        this.variant = this.getSelectedVariant();
        this.updateAvailability();
        this.updateAddToCartButton();
      });
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      this.updateVisibleOptions();
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();
      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;

      if (this.variant) {
        this.updateMedia();
        this.updateUrl(evt);
        this.updateVariantInput();
        this.updateFormSku();
        this.updateBisBtn();
        this.updateBackInStock();
        this.updateDimsAndMaterial();
        this.updateOversizeCharge();
        this.updateTariff();
      }

      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice();
      this.updateWeight();
      this.updateBarcode();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      this.updateMetafieldVisibility();
      VariantPicker.updateLabelText(evt);

      if (!this.preSelection) {
        this.dispatchEvent(new CustomEvent('on:variant:change', {
          bubbles: true,
          detail: {
            form: this.productForm,
            variant: this.variant,
            product: this.data.product
          }
        }));
      }
    }

    /**
     * Shows/hides variant metafield elements on the page as necessary
     */
    updateMetafieldVisibility() {
      document.querySelectorAll('[data-variant-metafield]').forEach((elem) => {
        elem.classList.toggle('hidden', elem.dataset.variantMetafield !== this.variant?.id.toString());
      });
    }

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton() {
      this.productForm = this.section.querySelector('.js-product-form-main');
      if (!this.productForm) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;

      // All variants hidden (discontinued dead end): keep the server-rendered
      // sold-out state instead of treating the empty selection as pre-selection.
      if (this.visibleVariants.length === 0) {
        this.addBtn.disabled = true;
        this.addBtn.textContent = theme.strings.noStock;
        return;
      }

      this.addBtn.disabled = !variantAvailable || this.preSelection;

      if (this.preSelection) {
        this.addBtn.textContent = theme.strings.noSelectedVariant;
      } else {

        const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;
        this.addBtn.textContent = variantAvailable
          ? this.addBtn.dataset.addToCartText
          : unavailableStr;
      }
    }

    /**
     * Update Dimensions and Materials as per the variant changes. Picks up the metafield from the json and updates as the variants are switched.
     */
     updateDimsAndMaterial() {
        if (!this.variant) return;

        const dim = this.data.formatted?.[this.variant.id]?.dim;
        const material = this.data.formatted?.[this.variant.id]?.material;

        // Find the containers fresh each time (works across sections/templates)
        const dimsEl = document.querySelector('#variant-dim');
        const materialEl = document.querySelector('#variant-material');

        if (dimsEl) {
          dimsEl.textContent = dim || '';
          const row = dimsEl.closest('li');
          if (row) row.style.display = dim ? '' : 'none';
        }

        /* B5P S3: size at a glance (snippets/umbra-size-glance.liquid), same value and parse as there: exactly three
           numbers split by x, with the axis letters and unit from its attributes; anything else hides it. */
        const glance = (this.section || document).querySelector('[data-umbra-size-glance]');
        if (glance) {
          const parts = (dim || '').split('x').map((p) => p.trim());
          const axes = (glance.dataset.axes || '').split(',').map((a) => a.trim());
          const ok = parts.length === 3 && axes.length === 3 && parts.every((p) => /^[0-9.]+$/.test(p));
          glance.textContent = ok ? `${parts.map((p, i) => `${axes[i]} ${p}`).join(' x ')} ${glance.dataset.unit || ''}`.trim() : '';
          glance.hidden = !ok;
        }

        if (materialEl) {
          materialEl.textContent = material || '';
          const row = materialEl.closest('li');
          if (row) row.style.display = material ? '' : 'none';
        }
      }
    
    /**
     * Update Back in stock dates for the not available products. for empty or null.
     */
     updateBackInStock() {
       let bisDate = this.data.formatted[this.variant.id].bisDate;
      let inStock = this.data.formatted[this.variant.id].inStock;
       let preOrder = this.data.formatted[this.variant.id].preOrder;
       if( !bisDate || bisDate === "TBD" || !this.variant || inStock ){
          if(this.backInStock) this.backInStock.style.display = "none";
           return;
       }
       if(this.backInStock){
         this.backInStock.style.display = "block";
         let dateContainer = this.backInStock.querySelector('#bis-date');
         dateContainer.textContent = bisDate;   
       }      
    }

    /**
     * Update Oversize Surcharge for the not available products. for empty or null.
     */
    updateOversizeCharge() {
      let oversize = this.data.formatted[this.variant.id].oversize;
      if( !oversize || !this.variant || !this.oversizeContainer ){
         if(this.oversizeContainer) this.oversizeContainer.hidden = true;
          return;
      } 
      // Multistore: the tier amounts are theme settings printed as data-tier-N on #oversize-info (or on
      // #oversize-quick-add, which copies them). Without them, the former US constants. A tier whose amount
      // resolves to nothing for this currency (or an unknown tier name) is no surcharge: hide, like quick-add.
      const tierInfo = this.oversizeContainer.closest('[data-tier-1]') || this.section.querySelector('#oversize-info[data-tier-1]');
      const tier = (n, fallback) => (tierInfo ? tierInfo.getAttribute('data-tier-' + n) : fallback);
      let amount = '';
      if(oversize === "Tier 1"){
        amount = tier(1, "10")
      }else if(oversize === "Tier 2"){
        amount = tier(2, "15")
      }else if(oversize === "Tier 3"){
        amount = tier(3, "5")
      }
      if(!amount){
        this.oversizeContainer.hidden = true;
        return;
      }
      this.oversizeContainer.hidden = false;
      this.oversizeCharge.textContent = amount;
   }

   /**
 * Update tariff display on variant change.
 */
updateTariff() {
  // Guard BEFORE the dereferences below, not after. The existing check further down tests
  // !tariff || !this.variant || !this.tariffContainer, but by then this.tariffData.formatted and
  // this.variant.id have already been read - so a page without the tariff block, or a variant that
  // is not selectable, threw here instead of hiding the callout.
  if (!this.tariffData || !this.tariffData.formatted || !this.variant) {
    if (this.tariffContainer) this.tariffContainer.hidden = true;
    return;
  }

  let tariff = this.tariffData.formatted[this.variant.id]?.tariff;
  let price = this.data.formatted[this.variant.id].price;
  let compareAtPrice = this.data.formatted[this.variant.id].compareAtPrice;
  let tier1percentage = this.tariffData.formatted.percentage["tier1"];
  let tier2percentage = this.tariffData.formatted.percentage["tier2"];
  let tier3percentage = this.tariffData.formatted.percentage["tier3"];
  let tier4percentage = this.tariffData.formatted.percentage["tier4"];

  if (!tariff || !this.variant || !this.tariffContainer) {
    if (this.tariffContainer) this.tariffContainer.hidden = true;
    return;
  }

  // Convert price strings to numerical values (removing any currency symbols)
  let numericPrice = parseFloat(price.replace(/[^\d.]/g, ''));
  let numericCompareAtPrice = compareAtPrice ? parseFloat(compareAtPrice.replace(/[^\d.]/g, '')) : numericPrice;

  let percentage;
  if (tariff.includes("ImportTier1")) {
    percentage = tier1percentage;
  } else if (tariff.includes("ImportTier2")) {
    percentage = tier2percentage;
  } else if (tariff.includes("ImportTier3")) {
    percentage = tier3percentage;
  } else if (tariff.includes("ImportTier4")) {
    percentage = tier4percentage;
  } else {
    percentage = 0; // default case
  }

  // Calculate the tariff amount based on the determined percentage
  let calculatedTariff = numericPrice * percentage;

  // Format tariff text content, skipping trailing zeros if .00
  this.tariffCharge.textContent = calculatedTariff % 1 === 0 ? calculatedTariff.toFixed(0) : calculatedTariff.toFixed(2);

  // Ensure the container is visible
  this.tariffContainer.hidden = false;
}

    /**
     * Updates the availability status of an option.
     * @param {Element} optionEl - Option element.
     * @param {boolean} exists - Does this option lead to a variant that exists?
     * @param {boolean} available - Does this option lead to a variant that is available to buy?
     */
    static updateOptionAvailability(optionEl, exists, available) {
      const el = optionEl;
      const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
      el.classList.toggle('is-unavailable', !available);
      el.classList.toggle('is-nonexistent', !exists);

      if (optionEl.classList.contains('custom-select__option')) {
        const em = el.querySelector('em');

        if (em) {
          em.hidden = available;
        }

        if (!available) {
          if (em) {
            em.textContent = unavailableText;
          } else {
            el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
          }
        }
      } else if (!available) {
        el.nextElementSibling.title = unavailableText;
      } else {
        el.nextElementSibling.removeAttribute('title');
      }
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === 'false') return;
      const { availabilityMethod } = this.dataset; // 'downward' or 'selection'
      let currVariant = this.variant;

      if (!this.variant) {
        currVariant = { options: this.selectedOptions };
      }

      if (availabilityMethod === 'selection') {
        // Flag all options as unavailable
        this.querySelectorAll('.js-option').forEach((optionEl) => {
          VariantPicker.updateOptionAvailability(optionEl, false, false);
        });

        // Flag selector options as available or sold out, depending on the variant availability
        this.optionSelectors.forEach((selector, selectorIndex) => {
          this.visibleVariants.forEach((variant) => {
            let matchCount = 0;

            variant.options.forEach((option, optionIndex) => {
              if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
                matchCount += 1;
              }
            });

            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll('.js-option');
              const optionEl = Array.from(options).find((opt) => {
                if (selector.dataset.selectorType === 'dropdown') {
                  return opt.dataset.value === variant.options[selectorIndex];
                }
                return opt.value === variant.options[selectorIndex];
              });

              if (optionEl) {
                VariantPicker.updateOptionAvailability(optionEl, true, variant.available);
              }
            }
          });
        });
      } else {
        this.optionSelectors.forEach((selector, selectorIndex) => {
          const options = selector.querySelectorAll('.js-option:not([data-value=""])');
          options.forEach((option) => {
            const optionValue = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
            // any available variants with previous options and this one locked in?
            let variantsExist = false;
            let variantsAvailable = false;
            this.visibleVariants.forEach((v) => {
              let matches = 0;
              for (let i = 0; i < selectorIndex; i += 1) {
                if (v.options[i] === this.selectedOptions[i] || this.selectedOptions[i] === null) {
                  matches += 1;
                }
              }
              if (v.options[selectorIndex] === optionValue && matches === selectorIndex) {
                variantsExist = true;
                if (v.available) {
                  variantsAvailable = true;
                }
              }
            });
            VariantPicker.updateOptionAvailability(option, variantsExist, variantsAvailable);
          });
        });
      }
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default')
            ? ''
            : ` - ${this.hasAttribute('data-umbra-hy') ? window.umbraOptionLabel(this.variant.title, this.data.product.options, this.dataset.umbraHy) : this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      if (!this.variant.featured_media) return;

      if (this.section.matches('quick-add-drawer')) {
        this.section.updateMedia(this.variant.featured_media.id);
      } else {
        this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');
        if (!this.mediaGallery) return;

        const variantMedia = this.mediaGallery.querySelector(
          `[data-media-id="${this.variant.featured_media.id}"]`
        );
        this.mediaGallery.setActiveMedia(variantMedia, true, true);
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price = this.price || this.section.querySelector('.product-info__price > .price');
      if (!this.price) return;

      let { variant } = this;
      if (this.preSelection) {
        const priceCandidates = this.visibleVariants.length > 0 ? this.visibleVariants : this.data.product.variants;
        [variant] = priceCandidates;
        for (let i = 1; i < priceCandidates.length; i += 1) {
          if (priceCandidates[i].price < variant.price) variant = priceCandidates[i];
        }
      }

      if (this.variant) {
        const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was');
        const unitPriceEl = this.price.querySelector('.unit-price');

        // Update current price and original price if on sale.
        priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price;
        if (priceWasEl)
          priceWasEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice || '';

        // Update unit price, if specified.
        if (this.variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = this.variant.unit_price_measurement.reference_value;
          const unit = this.variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
        }

        unitPriceEl.hidden = !this.variant.unit_price_measurement;
        this.price.classList.toggle(
          'price--on-sale',
          this.variant.compare_at_price > this.variant.price
        );
        this.price.classList.toggle('price--sold-out', !this.variant.available && !this.preSelection);
      }

      this.price.querySelector('.price__default').hidden = !this.variant && !this.preSelection;
      this.price.querySelector('.price__no-variant').hidden = this.variant || this.preSelection;
      const from = this.price.querySelector('.price__from');
      if (from) {
        from.hidden = !this.preSelection;
      }
    }

    /**
     * Updates the weight.
     */
    updateWeight() {
      this.weights = this.weights || this.section.querySelectorAll('.product-info__weight');
      if (this.weights.length === 0) return;

      const weightAvailable = this.variant && this.variant.weight > 0;
      this.weights.forEach((weight) => {
        weight.textContent = weightAvailable ? this.data.formatted[this.variant.id].weight : '';
        weight.hidden = !weightAvailable;
      });
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcodes = this.barcodes || this.section.querySelectorAll('.product-info__barcode-value');
      if (this.barcodes.length === 0) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcodes.forEach((barcode) => {
        barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
        barcode.parentNode.hidden = !barcodeAvailable;
      });
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');

      const detailsSku = document.querySelector('.product-details #variant-sku');

      const skuAvailable = this.variant && this.variant.sku;
      const newSku = skuAvailable ? this.variant.sku : '';

      if (this.sku) {
        this.sku.textContent = newSku;
        this.sku.parentNode.hidden = !skuAvailable;
      }

      if (detailsSku) {
        detailsSku.textContent = newSku;

        const li = detailsSku.closest('li');
        if (li) li.style.display = skuAvailable ? '' : 'none';
      }
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms || this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');

       if(!this.forms || this.forms.length === 0){
        this.forms = this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');
      }

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

          /**
     * Updates the value of the hidden [name="sku"] form inputs. This function is needed to be updated for live inventory checks.
     */
    updateFormSku() {
      this.forms =
        this.forms || this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');

       if(!this.forms || this.forms.length === 0){
        this.forms = this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');
      }
      
      this.forms.forEach((form) => {
        const formSku = form.querySelector('input[name="sku"]');
        formSku.value = this.variant.sku;
        formSku.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Updates the value of the get notified button attributes. This function is needed to be updated for correct variant in back in stock modals.
     */
    updateBisBtn() {
      this.forms = this.section.querySelectorAll('.js-klaviyo-form');

      this.forms.forEach((form) => {
        const bisBtn = form.querySelector('button[name="klaviyo-button"]');
        bisBtn.dataset.vid = this.variant.id;
        bisBtn.dataset.variant = this.variant.title
        bisBtn.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          const selectedText = selector.querySelector('.custom-select__btn').textContent.trim();
          selectedOptions.push(selectedText === this.dataset.placeholderText ? null : selectedText);
        } else {
          const selected = selector.querySelector('input:checked');
          selectedOptions.push(selected ? selected.value : null);
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Parses the ,id,id, hidden-variant list from the data-hidden-ids attribute.
     * @returns {number[]} Array of hidden variant IDs.
     */
    getHiddenIds() {
      const raw = this.dataset.hiddenIds || '';
      return raw
        .split(',')
        .map((s) => parseInt(s.trim(), 10))
        .filter((n) => !Number.isNaN(n));
    }

    /**
     * Gets the tariff data.
     * @returns {?object}
     */
    getTariffData() {
      // #importDuties is emitted by the PDP's `tariff` block in templates/product.json, and this
      // reads the GLOBAL document - so on a collection page it is simply not there. The old version
      // dereferenced it unguarded, inside the constructor (:40), which meant the VariantPicker threw
      // before it finished constructing and the custom element never upgraded.
      //
      // That is why the quick-add drawer's colour swatches did nothing: no upgrade means no
      // 'on:variant:change' is ever dispatched, so the image, price and availability all stayed put.
      // CLAUDE.md records this as a PDP trap (remove the tariff block and the PDP breaks); it is
      // equally a collection-page trap, and that half was not known.
      //
      // Returns null rather than {} so updateTariff() can tell "no tariff data on this page" from
      // "tariff data with nothing for this variant". updateTariff() is guarded to match.
      const dataEl = document.getElementById('importDuties');
      if (!dataEl) return null;
      try {
        return JSON.parse(dataEl.textContent);
      } catch (e) {
        return null;
      }
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant() {
      const selectedOptions = this.getSelectedOptions();
      return this.visibleVariants.find(
        (v) => v.options.every((val, index) => val === selectedOptions[index])
      );
    }

    /**
     * Bidirectional cascade: hide a listed option value only when the ONLY thing
     * ruling it out is hidden variants — i.e. some variant (visible or not) has that
     * value and matches the current selection on the OTHER options, but no VISIBLE
     * variant does. Combos that never existed as variants at all stay visible and are
     * left to updateAvailability() to grey out, matching pre-existing behavior on
     * products with no hidden variants. When a change makes another option's selected
     * value unreachable (for the same hiding-only reason), clear that option (shopper
     * re-chooses). Repeats to a fixpoint for 3+ option products. Dropdown-style
     * selectors are left to updateAvailability() + the cart guard.
     */
    updateVisibleOptions() {
      const selectorEls = Array.from(this.optionSelectors);

      const reachableIn = (variants, optionIndex, value, selected) =>
        variants.some(
          (v) =>
            v.options[optionIndex] === value &&
            selected.every(
              (sel, j) => j === optionIndex || sel == null || v.options[j] === sel
            )
        );

      const reachable = (optionIndex, value, selected) =>
        reachableIn(this.visibleVariants, optionIndex, value, selected);

      const reachableAll = (optionIndex, value, selected) =>
        reachableIn(this.data.product.variants, optionIndex, value, selected);

      // Clear-on-invalid to a fixpoint (listed selectors only — uncheck the radio).
      // Only clear when hiding is what caused the value to become unreachable.
      let changed = true;
      while (changed) {
        changed = false;
        const selected = this.getSelectedOptions();
        selected.forEach((sel, i) => {
          if (selectorEls[i].dataset.selectorType === 'dropdown') return;
          if (
            sel != null &&
            !reachable(i, sel, selected) &&
            reachableAll(i, sel, selected)
          ) {
            const checked = selectorEls[i].querySelector('input:checked');
            if (checked) {
              checked.checked = false;
              changed = true;
            }
          }
        });
      }

      // Show/hide each listed value by reachability against the (cleared) selection.
      // A value stays visible if it's reachable among visible variants, or if it was
      // never reachable at all (never-existed combo — not a hiding-caused gap).
      const selected = this.getSelectedOptions();
      selectorEls.forEach((selector, i) => {
        if (selector.dataset.selectorType === 'dropdown') return;
        selector.querySelectorAll('.js-option').forEach((input) => {
          const show =
            reachable(i, input.value, selected) || !reachableAll(i, input.value, selected);
          const label = input.nextElementSibling;
          input.style.display = show ? '' : 'none';
          if (label) label.style.display = show ? '' : 'none';
          if (!show) input.checked = false;
        });
      });
    }

    /**
     * Fires only when the server-intended initial variant (data-initial-variant-id,
     * set from product.selected_or_first_available_variant) is hidden. The Liquid
     * template has already pre-checked the visible default in the DOM, so this just
     * dispatches one 'change' event off the already-checked inputs to run the normal
     * pipeline (price, media, forms, and the URL all sync to match what's checked).
     * No-op when nothing is checked (no-preselection mode) or when there is no
     * visible variant (dead-end product). Also a no-op when any selector is
     * dropdown-style (see inline comment).
     */
    redirectIfHidden() {
      // Dropdown-style selectors can't be re-driven programmatically here (their
      // options are <li> elements managed by custom-select). Skip the redirect and
      // rely on updateAvailability() + the add-to-cart guard, matching the
      // cascade's dropdown carve-out.
      if (
        Array.from(this.optionSelectors).some(
          (s) => s.dataset.selectorType === 'dropdown'
        )
      ) return;

      if (this.visibleVariants.length === 0) return;

      const initialId = parseInt(this.dataset.initialVariantId, 10);
      if (Number.isNaN(initialId) || !this.hiddenIds.includes(initialId)) return;

      const checked = this.querySelectorAll('.js-option:checked');
      if (checked.length === 0) return;

      // Run the normal change pipeline (updates price, media, forms, and the URL
      // via updateUrl, which respects data-update-url) off the already-checked
      // (visible-default) inputs.
      checked[checked.length - 1].dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  customElements.define('variant-picker', VariantPicker);
}
